import { apiRequest } from './axiosConfig';

export type RecentWorkType = 'chat' | 'image' | 'video' | 'manga' | 'lp' | 'music';

export interface RecentWorkItem {
  id: string;
  type: RecentWorkType;
  title: string;
  subtitle: string;
  updated_at: string;
  thumbnail_url: string | null;
  deep_link: string;
  status: string | null;
}

export interface RecentWorksResponse {
  data: RecentWorkItem[];
  current_page: number;
  per_page: number;
  last_page: number;
  total: number;
}

export const fetchRecentWorks = async (
  page = 1,
  perPage = 50,
  types?: RecentWorkType[],
  lang?: 'ja' | 'en',
): Promise<RecentWorksResponse> => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('per_page', String(perPage));
  if (types && types.length > 0) {
    params.set('types', types.join(','));
  }
  if (lang === 'en') {
    params.set('lang', 'en');
  }
  return apiRequest.get<RecentWorksResponse>(`recent-works?${params.toString()}`);
};
